var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 120,
    viewBox: "130 35 320 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -3,
    width: 489,
    height: 217
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2584 181.175L55.1372 200.614L87.7953 146.183L120.453 160.18L158.555 118.191L203.654 129.077L223.871 97.1962L275.969 104.971L321.068 76.2012L371.61 63.76L406.601 38.1L460.254 0.000103611",
    stroke: "#3A7341",
    strokeWidth: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 24,
    width: 320,
    height: 184,
    fill: "#3A7341"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLine);
export default __webpack_public_path__ + "static/media/graph_line.549fbe617fc9a1ad5babb95f22d3dae3.svg";
export { ForwardRef as ReactComponent };